module.exports = __webpack_public_path__ + "static/media/city.cb7412e3.svg";